import React from 'react'
import { Row, Col, Form, Input, Select, Upload, Button, message } from 'antd'
import { UploadOutlined } from '@ant-design/icons'
import MemoryStore from '../../../../../utils/memory-store'

import 'brace/mode/json'
import 'brace/theme/xcode'

class ConnectorsFormTypeSnowflake extends React.Component {
  constructor(props) {
    super(props)

    this.entry = MemoryStore.activeEntries[this.props.tabKey]

    this.disabled = MemoryStore.userProfile.teamPrivileges.connectors === 'Reader'
    this.state = { entry: props.entry || {} }

    // Bindings
    this.onFieldChange = this.onFieldChange.bind(this)
    this.handleFileUpload = this.handleFileUpload.bind(this)
    this.handlePrivateKeyReset = this.handlePrivateKeyReset.bind(this)
  }

  onFieldChange(key, value) {
    this.entry.custom.isModified = true
    this.props.entry[key] = value
  }

  handleFileUpload(info) {
    if (info.fileList.length > 0) {
      const file = info.fileList[0].originFileObj
      const reader = new FileReader()
      reader.onload = (e) => {
        const content = e.target.result
        this.onFieldChange('privateKey', content)
        this.setState({ entry: { ...this.state.entry, privateKey: content } })
        message.success(`${info.file.name} file uploaded successfully.`)
      }
      reader.readAsText(file)
    }
  }

  handlePrivateKeyReset() {
    this.onFieldChange('privateKey', '')
    this.setState({
      entry: {
        ...this.state.entry,
        privateKey: ''
      }
    })
    message.success('Private key has been reset. You can now upload a new private key.')
  }

  render() {
    const authTypeOptions = [
      { label: 'Password', value: 'password' },
      { label: 'OAuth', value: 'oauth' },
      { label: 'Key-Pair', value: 'key_pair' }
    ]

    return (
      <Row>
        <Col xs={24} lg={16}>
          <Form.Item>
            <span style={{ color: 'red' }}>* </span>
            {'Authentication Type'}
            <Select
              name='authType'
              defaultValue={this.props.authType}
              options={authTypeOptions}
              onChange={(value) => {
                this.onFieldChange('authType', value)
                this.props.setAuthType(value)
              }}
            />
          </Form.Item>
          <>
            <Form.Item>
              <span style={{ color: 'red' }}>* </span>
              {'Account'}
              <Input
                name='account'
                placeholder='Snowflake Account'
                disabled={this.disabled}
                defaultValue={this.state.entry.account}
                onChange={(e) => {
                  this.onFieldChange('account', e.target.value)
                }}
              />
            </Form.Item>
            {(this.props.authType === 'password' || this.props.authType === 'key_pair') && (
              <>
                <Form.Item>
                  <span style={{ color: 'red' }}>* </span>
                  {'Username'}
                  <Input
                    name='username'
                    placeholder='Username'
                    disabled={this.disabled}
                    defaultValue={this.state.entry.username}
                    onChange={(e) => {
                      this.onFieldChange('username', e.target.value)
                    }}
                  />
                </Form.Item>
                {this.props.authType !== 'key_pair' && (
                  <Form.Item>
                    <span style={{ color: 'red' }}>* </span>
                    {'Password'}
                    <Input
                      name='password'
                      placeholder='Database password'
                      disabled={this.disabled}
                      defaultValue={this.state.entry.password}
                      autoComplete='new-password'
                      type='password'
                      onChange={(e) => {
                        this.onFieldChange('password', e.target.value)
                      }}
                    />
                  </Form.Item>
                )}
              </>
            )}
            {this.props.authType === 'oauth' && (
              <>
                <Form.Item>
                  <span style={{ color: 'red' }}>* </span>
                  {'Client ID'}
                  <Input
                    name='clientId'
                    placeholder='Client ID'
                    disabled={this.disabled}
                    defaultValue={this.state.entry.clientId}
                    onChange={(e) => {
                      this.onFieldChange('clientId', e.target.value)
                    }}
                  />
                </Form.Item>
                <Form.Item>
                  <span style={{ color: 'red' }}>* </span>
                  {'Client Secret'}
                  <Input
                    name='clientSecret'
                    placeholder='Client Secret'
                    disabled={this.disabled}
                    defaultValue={this.state.entry.clientSecret}
                    type='password'
                    onChange={(e) => {
                      this.onFieldChange('clientSecret', e.target.value)
                    }}
                  />
                </Form.Item>
                <Form.Item>
                  <span style={{ color: 'red' }}>* </span>
                  {'Authorization Endpoint'}
                  <Input
                    name='authorizationEndpoint'
                    placeholder='Authorization Endpoint'
                    disabled={this.disabled}
                    defaultValue={this.state.entry.authorizationEndpoint}
                    onChange={(e) => {
                      this.onFieldChange('authorizationEndpoint', e.target.value)
                    }}
                  />
                </Form.Item>
                <Form.Item>
                  <span style={{ color: 'red' }}>* </span>
                  {'Token Endpoint'}
                  <Input
                    name='tokenEndpoint'
                    placeholder='Token Endpoint'
                    disabled={this.disabled}
                    defaultValue={this.state.entry.tokenEndpoint}
                    onChange={(e) => {
                      this.onFieldChange('tokenEndpoint', e.target.value)
                    }}
                  />
                </Form.Item>
                <Form.Item>
                  {'Scope'}
                  <Input
                    name='scope'
                    placeholder='Scope'
                    disabled={this.disabled}
                    defaultValue={this.state.entry.scope}
                    onChange={(e) => {
                      this.onFieldChange('scope', e.target.value)
                    }}
                  />
                </Form.Item>
              </>
            )}
            {this.props.authType === 'key_pair' && (
              <>
                <Form.Item>
                  <span style={{ color: 'red' }}>* </span>
                  {'Private Key File'}
                  <br />
                  {this.state.entry.privateKey ? (
                    <>
                      <Button
                        onClick={this.handlePrivateKeyReset}
                        disabled={this.disabled}
                        style={{ marginBottom: '8px' }}
                      >
                        Reset Private Key
                      </Button>
                      <div style={{ fontSize: '12px', color: 'green' }}>Private key loaded</div>
                    </>
                  ) : (
                    <Upload
                      name='privateKeyFile'
                      accept='.p8,.pem,.key'
                      maxCount={1}
                      disabled={this.disabled}
                      beforeUpload={() => false} // Prevent automatic upload
                      onChange={this.handleFileUpload}
                      showUploadList={{
                        showPreviewIcon: false,
                        showRemoveIcon: !this.disabled
                      }}
                    >
                      <Button icon={<UploadOutlined />} disabled={this.disabled}>
                        Upload Private Key File
                      </Button>
                    </Upload>
                  )}
                </Form.Item>
                <Form.Item>
                  {'Private Key Passphrase'}
                  <Input
                    name='privateKeyPassphrase'
                    type='password'
                    placeholder='Private Key Passphrase (if encrypted)'
                    disabled={this.disabled}
                    defaultValue={this.state.entry.privateKeyPassphrase}
                    onChange={(e) => {
                      this.onFieldChange('privateKeyPassphrase', e.target.value)
                    }}
                  />
                </Form.Item>
              </>
            )}
            <Form.Item>
              {'Database'}
              <Input
                name='database'
                placeholder='Database to connect to'
                disabled={this.disabled}
                defaultValue={this.state.entry.database}
                onChange={(e) => {
                  this.onFieldChange('database', e.target.value)
                }}
              />
            </Form.Item>
            <Form.Item>
              {'Schema'}
              <Input
                name='schema'
                placeholder='Schema'
                disabled={this.disabled}
                defaultValue={this.state.entry.schema}
                onChange={(e) => {
                  this.onFieldChange('schema', e.target.value)
                }}
              />
            </Form.Item>
            <Form.Item>
              {'Warehouse'}
              <Input
                name='warehouse'
                placeholder='Warehouse'
                disabled={this.disabled}
                defaultValue={this.state.entry.warehouse}
                onChange={(e) => {
                  this.onFieldChange('warehouse', e.target.value)
                }}
              />
            </Form.Item>
            <Form.Item>
              {'Role'}
              <Input
                name='role'
                placeholder='Role'
                disabled={this.disabled}
                defaultValue={this.state.entry.role}
                onChange={(e) => {
                  this.onFieldChange('role', e.target.value)
                }}
              />
            </Form.Item>
          </>
        </Col>
      </Row>
    )
  }
}

export default ConnectorsFormTypeSnowflake
